import { Link as JoyLink, type LinkProps as JoyLinkProps } from '@mui/joy';
import type { ForwardedRef, ReactElement } from 'react';
import type { LinkProps } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const GLink = (props: LinkProps & JoyLinkProps & { ref?: ForwardedRef<HTMLAnchorElement> }): ReactElement => {
  return (
    <JoyLink {...props} component={HashLink} ref={props.ref}>
      {props.children}
    </JoyLink>
  );
};

GLink.displayName = 'GLink';

export default GLink;
